export interface SquareButtonPropsModel {
  className?: string;
  onClick?: any;
  isFocused?: any;
  children?: any;
}

export const SquareButton = ({
  className,
  onClick,
  isFocused,
  children,
}: SquareButtonPropsModel) => {
  const classList = [
    'flex',
    'items-center',
    'justify-center',
    'w-10',
    'h-10',
    'border',
    'border-grey-10',
    'cursor-pointer',
    'select-none',
    'font-medium',
    'hover:bg-grey-10',
    'active:bg-grey-80',
    'active:text-primary',
    'focus:bg-primary',
    isFocused ? 'bg-primary' : '',
    className || '',
  ];

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className={classList.join(' ')} onClick={handleClick} tabIndex={0}>
      {children}
    </div>
  );
};
